var React = require('react');

function BenefitsBlobSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M73.0531 0.1713C87.0899 1.7399 94.2001 17.3522 105.019 26.4602C114.809 34.7014 126.678 40.014 133.363 50.9413C141.5 64.2431 148.537 79.1114 146.708 94.6101C144.674 111.848 137.257 129.742 122.917 139.456C108.725 149.07 89.8266 147.968 73.0531 144.505C58.5227 141.505 48.3772 129.987 36.16 121.544C23.5189 112.809 3.57294 109.352 0.383972 94.2888C-2.85408 78.9935 15.2643 68.083 21.841 53.9068C27.27 42.2042 26.5657 28.0164 35.4573 18.6866C45.347 8.3096 58.8304 -1.41808 73.0531 0.1713Z","fill":"#FECB4B"}));
}

BenefitsBlobSmall.defaultProps = {"width":"147","height":"147","viewBox":"0 0 147 147","fill":"none"};

module.exports = BenefitsBlobSmall;

BenefitsBlobSmall.default = BenefitsBlobSmall;
